import React from 'react';
import PropTypes from 'prop-types';

export const ContentPasteSearch = ({ width, height, ...props }) => (
  <svg
    data-icon='content-paste-search'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m20.6 22-2.7-2.7c-.367.217-.75.387-1.15.512-.4.125-.817.188-1.25.188-1.25 0-2.313-.438-3.188-1.313C11.438 17.813 11 16.75 11 15.5c0-1.25.438-2.313 1.313-3.188C13.187 11.438 14.25 11 15.5 11c1.25 0 2.313.438 3.188 1.313C19.563 13.187 20 14.25 20 15.5c0 .433-.063.85-.188 1.25s-.295.783-.512 1.15l2.7 2.7-1.4 1.4Zm-5.1-4c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C16.792 13.242 16.2 13 15.5 13s-1.292.242-1.775.725C13.242 14.208 13 14.8 13 15.5s.242 1.292.725 1.775c.483.483 1.075.725 1.775.725Zm5.5-8h-2V5h-2v3H7V5H5v14h5v2H5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h4.175c.183-.583.542-1.063 1.075-1.438A2.978 2.978 0 0 1 12 1a3 3 0 0 1 1.787.563c.525.375.88.854 1.063 1.437H19c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v5Zm-9-5c.283 0 .52-.096.713-.287A.967.967 0 0 0 13 4a.967.967 0 0 0-.287-.712A.968.968 0 0 0 12 3a.968.968 0 0 0-.713.288A.967.967 0 0 0 11 4c0 .283.096.52.287.713.192.191.43.287.713.287Z'
    />
  </svg>
);

ContentPasteSearch.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ContentPasteSearch.defaultProps = {
  width: 24,
  height: 24,
};
